import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { selectProfileRestricted } from '@webapp/account/src/resources/profile/selectors';
import { profileSlice } from '@webapp/account/src/resources/profile/slice';

import { Modal } from '@webapp/common/components/modal';
import { useActions } from '@webapp/common/hooks/use-actions';

import { AuthAlertEmail } from './auth-alert-email';
import { AuthAlertMessage } from './auth-alert-message';
import { AlertMode } from './lib';

import css from './auth-alert.css';

export const AuthAlert: FC = () => {
    const profileRestricted = useSelector(selectProfileRestricted);
    const [mode, setMode] = useState<AlertMode>(null);
    const isMessage = mode === AlertMode.MESSAGE;
    const logout = useActions(profileSlice.actions.logout);

    const handleOutClick = useCallback(
        (e: ReactMouseEvent<HTMLAnchorElement, MouseEvent>) => {
            e.preventDefault();
            logout();
        },
        [logout],
    );

    useEffect(() => {
        if (profileRestricted) {
            setMode(AlertMode.MESSAGE);
        }
    }, [profileRestricted]);

    if (!mode) {
        return null;
    }

    return (
        <Modal
            className={css.modal}
            closeBtn={false}
            visible={true}
            title={
                <span className={css.title}>
                    <span>{isMessage ? 'Подтвердите email' : 'Новый адрес электронной почты'}</span>
                    <a className={css.logout} onClick={handleOutClick}>
                        Выход
                    </a>
                </span>
            }
        >
            {isMessage ? <AuthAlertMessage setMode={setMode} /> : <AuthAlertEmail setMode={setMode} />}
        </Modal>
    );
};
